import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-40b4c772"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "m-que-box",
  ref: "refQueBox"
}
const _hoisted_2 = {
  class: "m-current-box",
  ref: "refCurrentBox"
}
const _hoisted_3 = { ref: "refMainCon" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_page = _resolveComponent("loading-page")!
  const _component_dot_que = _resolveComponent("dot-que")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.loading)
        ? (_openBlock(), _createBlock(_component_loading_page, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dotMap, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (item.interact_question_cfg.length && $setup.currentIndex)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (item.isLoaded && index === $setup.currentIndex)
                    ? (_openBlock(), _createBlock(_component_dot_que, {
                        key: 0,
                        isCurrent: $setup.currentIndex === index,
                        curTime: $setup.curTime,
                        questionList: item.interact_question_cfg,
                        dotIndex: index,
                        onHandleAfterRender: $setup.handleAfterRender,
                        class: _normalizeClass({'u-current-tile': index === $setup.currentIndex })
                      }, null, 8, ["isCurrent", "curTime", "questionList", "dotIndex", "onHandleAfterRender", "class"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ], 512),
      ($setup.isAfterSubmit)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "m-current-box-mask",
            onClick: _withModifiers(() => {}, ["stop"])
          }))
        : _createCommentVNode("", true)
    ], 512)
  ], 512))
}